import { render, staticRenderFns } from "./DeliveryList_Search.vue?vue&type=template&id=27bc6a9a&"
import script from "./DeliveryList_Search.vue?vue&type=script&lang=js&"
export * from "./DeliveryList_Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports